import { InvitationType } from '@/models/Invitations'
import { InvitationsService } from '@/service/InvitationService'
import { AxiosError } from 'axios'
import { reactive } from 'vue'
import { GroupState } from './groups'
import { UserState } from './users'
export class InvitationsState {
  state = reactive({
    invitationLink: '',
    inviteeDetails: new Map<string, string>(),
    showInvitationModal: false,
    forbiddenInvitation: false,
  })
  constructor() {}
  async createInvitation(invitationsPayload) {
    try {
      const invitation = await InvitationsService.create({
        ...invitationsPayload,
        locationId: GroupState.state.groupData.locationId,
        groupId: GroupState.state.groupData._id,
        invitationType:
        invitationsPayload?.invitationType || InvitationType.EMAIL,
      createdBy: UserState.state.currentUser?.contactId,
    })
    this.state.invitationLink =
        GroupState.state.groupLink + '?invite=' + invitation._id
    } catch (error) {
      const transformedError = error as AxiosError
      if(transformedError?.response?.status === 403){
        this.state.forbiddenInvitation = true
      }
    }
  }
  resetErrors() {
    this.state.forbiddenInvitation = false
  }
  async acceptInvitation(invitationId) {
    return InvitationsService.acceptInvitation(invitationId)
  }

  async cancelInvitation(invitationId) {
    return await InvitationsService.delete(invitationId)
  }

  async fetchInvitation(invitationId) {
    let invitee = this.state.inviteeDetails.get(invitationId)
    if (invitee) {
      return invitee
    }

    const invitations = await InvitationsService.findById(invitationId)
    this.state.inviteeDetails.set(
      invitationId,
      invitations._data[0].inviteeName
    )
    return invitations._data[0].inviteeName
  }
}
export const InvitationState = new InvitationsState()
